export function format(dateTime, showSeconds = true) {
  const hours = dateTime.getHours()
  const minutes =
    dateTime.getMinutes() < 10
      ? '0' + dateTime.getMinutes()
      : dateTime.getMinutes()
  let time = hours + ':' + minutes

  if (showSeconds) {
    const seconds =
      dateTime.getSeconds() < 10
        ? '0' + dateTime.getSeconds()
        : dateTime.getSeconds()
    time = time + ':' + seconds
  }
  return time
}
